export const tagsRel ={
    headers:[
        { key: "cnpj", label: "CNPJ"},
        { key: "empresa", label: "Empresa"},
        { key: "ano", label: "Ano"},
        { key: "captacaoAguaSuperficial", label: "Empresa realiza captação de água superficial"},
        { key: "captacaoTotalAguaSuperficial", label: "Captação total de água superficial(m³)"},
        { key: "captacaoTotalAguaMar", label: "Captação total de água do mar(m³)"},
        { key: "captacaoTotalAguaSubterranea", label: "Captação total de água subterrânea(m³)"},
        { key: "captacaoTotalAguaTerceiros", label: "Captação total de água de terceiros(m³)"},
        { key: "captacaoTotalAguaChuva", label: "Captação total de água de chuva(m³)"},
        { key: "captacaoTotalAguaMinerio", label: "Captação total de água presente no minério(m³)"},
        { key: "devolucaoMeioAmbiente", label: "Devolução ao meio ambiente(m³)"},
        { key: "disponibilizacaoTerceiros", label: "Disponibilização a terceiros(m³)"},
        { key: "observacao", label: "Observações"},
        { key: "createdAt", label: "Inserido"},
        { key: "updatedAt", label: "Atualizado"},
        
    ]
}